import { useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import TextScramble from '../components/TextScramble';
import ScrollReveal from '../components/ScrollReveal';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ContactPage() {
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await axios.post(`${API}/inquiries`, form);
      setSubmitted(true);
    } catch (err) {
      console.error(err);
    } finally {
      setSubmitting(false);
    }
  };

  if (submitted) {
    return (
      <div data-testid="contact-success" className="pt-28 pb-24 min-h-screen flex items-center justify-center">
        <div className="text-center max-w-md px-4">
          <h1 className="font-serif text-4xl sm:text-5xl font-light mb-6" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
            Message Envoy&eacute;
          </h1>
          <p className="text-black/50 text-sm mb-10">Merci de nous avoir contact&eacute;s. Nous vous r&eacute;pondrons dans les plus brefs d&eacute;lais.</p>
          <Link to="/" className="btn-primary inline-block">Retour &agrave; l'Accueil</Link>
        </div>
      </div>
    );
  }

  return (
    <div data-testid="contact-page" className="pt-24 sm:pt-28 pb-24">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <ScrollReveal>
          <div className="text-center mb-16">
            <TextScramble
              text="Contactez-Nous"
              className="text-5xl sm:text-6xl tracking-tighter font-light text-black"
              delay={0.2}
            />
            <p className="mt-4 text-base text-black/50 max-w-md mx-auto">
              Vous avez une question sur nos produits ou votre peau ? Nous sommes l&agrave; pour vous aider.
            </p>
          </div>
        </ScrollReveal>

        <ScrollReveal delay={0.2}>
          <form data-testid="contact-form" onSubmit={handleSubmit} className="space-y-6 max-w-lg mx-auto">
            <input
              data-testid="contact-name-input"
              type="text"
              placeholder="Votre Nom"
              value={form.name}
              onChange={e => setForm({...form, name: e.target.value})}
              required
              className="bg-transparent border-b border-black/20 focus:border-black outline-none py-3 w-full text-sm transition-colors"
            />
            <input
              data-testid="contact-email-input"
              type="email"
              placeholder="Adresse E-mail"
              value={form.email}
              onChange={e => setForm({...form, email: e.target.value})}
              required
              className="bg-transparent border-b border-black/20 focus:border-black outline-none py-3 w-full text-sm transition-colors"
            />
            <input
              data-testid="contact-subject-input"
              type="text"
              placeholder="Sujet"
              value={form.subject}
              onChange={e => setForm({...form, subject: e.target.value})}
              required
              className="bg-transparent border-b border-black/20 focus:border-black outline-none py-3 w-full text-sm transition-colors"
            />
            <textarea
              data-testid="contact-message-input"
              placeholder="Votre Message"
              value={form.message}
              onChange={e => setForm({...form, message: e.target.value})}
              required
              rows={4}
              className="bg-transparent border-b border-black/20 focus:border-black outline-none py-3 w-full text-sm transition-colors resize-none"
            />
            <button
              data-testid="contact-submit-btn"
              type="submit"
              disabled={submitting}
              className="btn-primary w-full"
            >
              {submitting ? 'Envoi en cours...' : 'Envoyer le Message'}
            </button>
          </form>
        </ScrollReveal>
      </div>
    </div>
  );
}
